import React from 'react'
import AdhesivesProductList from './AdhesivesProductList'
import AppNavigation from '../../AppNavigation'

export default function AdhesivesProductSelection() {
   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
               <AdhesivesProductList />
         </div>
         <AppNavigation />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/adhesives/AdhesivesProductSelection.js